import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { setOptions, switchModule } from "../../../actions/display";
import IdleLoop from "../../../containers/IdleLoop";
import shared from "../../../utils/shared.js";
import AttractLoopOmaha from "./AttractLoopOmaha";
import NavOmaha from "./NavOmaha";
import OmahaRecognitionList from "./OmahaRecognitionList.jsx";
import StoriesOmaha from "./StoriesOmaha";
import StoryOmaha from "./StoryOmaha";

class OmahaContainer extends Component {
  constructor(props) {
    super(props);
    this._screensNumber = this.getScreensNumber();
    this.idleRef = 0;
    this._module = null;

    const attractLoopSlideshowModule = this.getAttractLoopFolderModule();

    this.state = {
      idle: false,
      menuUrl: "/omaha/nav",
      showNavButton: false,
      module: null,
      attractLoopSlideshowModule
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  getAttractLoopFolderModule = () => {
    const attractLoopFolder = this.props.content.story_categories.find((folder) => {
      const type = _.get(folder, "contents.custom_fields.folder_type.val.value", null);
      return type === "attract_loop";
    });
    if (!attractLoopFolder) return null;
    const childAttractLoopFolderModule = this.props.content.folder_modules.find(
      (fm) => fm.folder === attractLoopFolder.id
    );
    const attractLoopSlideshowModule = this.props.content.dm_active.find(
      (dm) => dm.id === childAttractLoopFolderModule.module_id
    );
    return attractLoopSlideshowModule;
  };

  toggleShowNav = (toggleOn) => {
    this.setState({
      showNavButton: toggleOn
    });
  };

  navRoute = (route, module) => {
    if (module) {
      this.setState({
        module
      });
    }
    this.props.history.replace(route);
  };

  getScreensNumber = () => {
    try {
      return this.props.content.settings.display_blocks[0].screens.length;
    } catch (e) {
      return 1;
    }
  };

  goIdle = (type ) => {
    if (type === 'idle') {
      if (!this.state.idle) {
        this.setState({
          idle: true
        });
        if (this.state.attractLoopSlideshowModule) {
          this.navRoute("/omaha/slideshow");
        } else {
          this.navRoute("/omaha/nav");
        }
      }
    }
  };

  resume = () => {
    const newIdle = this.state.idle ? false : this.state.idle;
    if (newIdle !== this.state.idle) {
      this.setState(
        {
          idle: newIdle
        },
        () => {
          this.navRoute("/omaha/nav")
        }
      );
    }
  };

  handleKeyDown = (event) => {
    switch (event.key) {
      case "s":
        console.log(this.props);
        break;
      case "n":
        this.props.history.replace(this.state.menuUrl);
        break;
      default:
        break;
    }
  };

  render() {
    const { location } = this.props;
    const key = this.props.location.pathname + this.props.location.search;
    return (
      <div className={this.props.content.font_class} style={{ color: this.props.content.settings.main_font_color }}>
        <CSSTransitionGroup
          component="div"
          className="containerFade"
          transitionName="fastfadedelay"
          style={{ minHeight: "100%" }}
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}
        >
          <Switch key={key} location={location}>
            <Route
              path="/omaha/slideshow"
              render={(props) => (
                <AttractLoopOmaha
                  {...props}
                  module={this.state.attractLoopSlideshowModule}
                  navRoute={this.navRoute}
                  screen={this.props.screen}
                  screensNumber={this._screensNumber}
                />
              )}
            />

            <Route
              path="/omaha/nav"
              render={(props) => (
                <NavOmaha
                  {...props}
                  toggleShowNav={this.toggleShowNav}
                  navRoute={this.navRoute}
                  content={this.props.content}
                  screen={this.props.screen}
                  screensNumber={this._screensNumber}
                />
              )}
            />
            <Route
              path="/omaha/story"
              render={(props) => (
                <StoryOmaha
                  {...props}
                  backgroundEnabled={true}
                  module={this.state.module}
                  content={this.props.content}
                  navRoute={this.navRoute}
                  screen={this.props.screen}
                  screensNumber={this._screensNumber}
                />
              )}
            />
            <Route
              path="/omaha/stories"
              render={(props) => (
                <StoriesOmaha
                  {...props}
                  module={this.state.module}
                  navRoute={this.navRoute}
                  screen={this.props.screen}
                  content={this.props.content}
                  screensNumber={this._screensNumber}
                />
              )}
            />
            <Route
              path="/omaha/stories_story"
              render={(props) => (
                <StoryOmaha
                  {...props}
                  backgroundEnabled={true}
                  module={this.state.module}
                  content={this.props.content}
                  navRoute={this.navRoute}
                  screen={this.props.screen}
                  screensNumber={this._screensNumber}
                />
              )}
            />
            <Route
              path="/omaha/recognition_list"
              render={(props) => (
                <OmahaRecognitionList
                  {...props}
                  content={this.props.content}
                  module={this.state.module}
                  navRoute={this.navRoute}
                  screen={this.props.screen}
                  screensNumber={this._screensNumber}
                />
              )}
            />
          </Switch>
        </CSSTransitionGroup>

        {/* Idle Loop */}
        {this.props.idleActive === true ? (
          <IdleLoop idle_delay={this.props.content.idle_delay} goIdle={this.goIdle} resume={this.resume} />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let active_module = state.active_module;
  let idle = shared.parseStringParam(window.location.href, "idle");
  let namedmodule = shared.parseStringParam(window.location.href, "name");

  let idleActive = true;
  if (state.content.idle_delay === 0 || idle === "false") {
    idleActive = false;
  }

  if (namedmodule) {
    active_module = _.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
  }

  return {
    active_module: active_module,
    content: state.content,
    contentHasErrored: state.contentHasErrored,
    contentIsLoading: state.contentIsLoading,
    donors: state.donors,
    donorsHasErrored: state.donorsHasErrored,
    donorsIsLoading: state.donorsIsLoading,
    screen: state.screen,
    options: state.options,
    screensNumber: state.screensNumber,
    idleActive: idleActive
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    switchModule: (id) => dispatch(switchModule(id)),
    setOptions: (data) => dispatch(setOptions(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OmahaContainer);



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/OmahaContainer.jsx